import { ActionTypes } from '../constants';
import { SyncStatus } from '../../enums';

const defaults = {
  status: SyncStatus.DISCONNECTED,
};

export interface CheckState {
  status: string;
}

export interface ActionType {
  type: string;
  payload: any;
}

export default (state: CheckState = defaults, action: ActionType) => {
  switch (action.type) {
    case ActionTypes.UPDATE_SYNC_STATUS: {
      const { status } = action.payload;
      return {
        ...state,
        status,
        timestamp: new Date().getTime(),
      };
    }
    default:
      return { ...state };
  }
};
